var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.886 44.6153L24.886 2.61534C24.541 1.95634 23.459 1.95634 23.115 2.61534L1.11497 44.6153C0.951969 44.9253 0.963969 45.2973 1.14497 45.5963C1.32597 45.8953 1.64997 46.0793 1.99997 46.0793H46C46.35 46.0793 46.674 45.8963 46.855 45.5973C47.036 45.2983 47.048 44.9253 46.886 44.6153ZM26.286 17.0793L25.143 33.6503H22.857L21.714 17.0793H26.286ZM24 42.0793C22.343 42.0793 21 40.7363 21 39.0793C21 37.4223 22.343 36.0793 24 36.0793C25.657 36.0793 27 37.4223 27 39.0793C27 40.7363 25.657 42.0793 24 42.0793Z",
    fill: "#D51F31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedWarning);
export default __webpack_public_path__ + "static/media/red-warning.cb613ffe76bad4e2dc17d1f7b2b79825.svg";
export { ForwardRef as ReactComponent };